import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { c as i } from "./index-DkZ16bcJ.mjs";
import { f as t } from "./index-LyFokDcn.mjs";
import { m as f } from "./tss-DN0acMKN.mjs";
import { M as u, d as p } from "./constants-CnFYFetN.mjs";
const w = f()(({ borderRadiuses: e, mode: o }) => ({
  root: {
    aspectRatio: "16 / 9",
    display: "flex",
    outline: o === u.Dye ? `2px solid ${p.main}` : void 0,
    overflow: "hidden",
    width: t.ifFeature("encore", "100%", "704px")
  },
  iframe: {
    aspectRatio: "inherit",
    height: "100%",
    width: "100%"
  },
  rounded: {
    borderRadius: t.ifFeature("encore", e[400], "10px")
  }
})), F = ({
  classes: e,
  className: o,
  embedOptions: a = "",
  wistiaId: l = "",
  iframeProps: d,
  square: m,
  ...n
}) => {
  const { classes: r } = w(void 0, { props: { classes: e } }), c = {
    mozallowfullscreen: "true",
    msallowfullscreen: "true",
    oallowfullscreen: "true",
    webkitallowfullscreen: "true"
  };
  return /* @__PURE__ */ s.jsx("div", { className: i(r.root, o, { [r.rounded]: !m }), ...n, "data-fabric-component": "WistiaVideo", children: /* @__PURE__ */ s.jsx(
    "iframe",
    {
      allowFullScreen: !0,
      className: i("wistia_embed", r.iframe),
      frameBorder: "0",
      name: "wistia_embed",
      scrolling: "no",
      src: `//fast.wistia.net/embed/iframe/${l}?videoFoam=true${a}`,
      title: "Video",
      ...c,
      ...d
    }
  ) });
};
export {
  F as W
};
//# sourceMappingURL=wistia-video-B4mxpqdB.mjs.map
